import { Redirect, router } from 'expo-router';
import { ScreenContainer, useToastController, YStack } from 'smoothie';

import PaymentMethodForm from '../../../billing/components/PaymentMethodForm';
import {
    SUCCESS_TOAST_DURATION,
    SuccessToastIcon,
} from '../../../member-profile/components/SuccessToast';

// Throwaway POC screen: mirrors the Figma "Change payment method" screen's
// content/functionality, not its exact visual design.
export default function PaymentMethodChangePage() {
    if (
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'local' &&
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'sandbox' &&
        process.env.EXPO_PUBLIC_FRUITFUL_ENV !== 'staging'
    ) {
        return <Redirect href="/" />;
    }

    const toast = useToastController();

    return (
        <ScreenContainer
            title="Change payment method"
            hasBackButton
            onFallbackRoute="/dev/stripe/payment-method"
        >
            <YStack gap={16} padding={16} width="100%">
                <PaymentMethodForm
                    description="Replace your current payment method by adding a new card below."
                    submitLabel="Save"
                    onSuccess={() => {
                        toast.show('Payment method changed', {
                            duration: SUCCESS_TOAST_DURATION,
                            icon: SuccessToastIcon,
                        });
                        router.replace('/dev/stripe/payment-method');
                    }}
                />
            </YStack>
        </ScreenContainer>
    );
}
